import React from 'react';
import SubstationFilters from './substation-filters';
import LoadMap from './map';
import jsonSchema from './substation-filters.json';
import Navbar from "../../components/Navbar/navbar";
import ErrorBoundary from "../../components/ErrorBoundary/ErrorBoundary";

const SubstationExplorer = () => {
  return (
    <ErrorBoundary>
      <div>
        <Navbar />
        <div className="filter-row row">
          <SubstationFilters substationTitle={jsonSchema.substationExplorerTitle} />
        </div>
        <div className='row'>
          <ErrorBoundary>
            <LoadMap />
          </ErrorBoundary>
        </div>
      </div>
    </ErrorBoundary>
  );
}
export default SubstationExplorer;

